import React from 'react';

const PRESETS = [
  {
    id: 'hospital',
    icon: '🏥',
    title: 'UGD RUMAH SAKIT',
    subtitle: 'Cakupan 24/7 — Shift 8 Jam',
    description: '8 Dokter & Perawat, 3 shift/hari, 7 hari kerja.',
    employees: [
      'dr. Andi (Sp.B)',
      'dr. Budi (Sp.A)',
      'dr. Citra (Umum)',
      'Ns. Dewi (ICU)',
      'Ns. Eko (UGD)',
      'Ns. Fajar (UGD)',
      'Ns. Gita (Triase)',
      'Ns. Hadi (Ranap)',
    ],
    shiftHours: 8,
    workingDays: 7,
  },
  {
    id: 'cafe',
    icon: '☕',
    title: 'KAFE 24 JAM',
    subtitle: 'Rotasi Cepat — Shift 6 Jam',
    description: '6 Barista & Staff, 4 shift/hari, 6 hari kerja.',
    employees: [
      'Alex (Head Barista)',
      'Bella (Barista)',
      'Charlie (Barista)',
      'Diana (Kasir)',
      'Evan (Kasir)',
      'Fiona (Kitchen)',
    ],
    shiftHours: 6,
    workingDays: 6,
  },
  {
    id: 'tech_support',
    icon: '📞',
    title: 'TECH SUPPORT 24/7',
    subtitle: 'Shift Panjang — Shift 12 Jam',
    description: '10 Engineer, 2 shift/hari, 7 hari kerja.',
    employees: [
      'L1 - Agung',
      'L1 - Bima',
      'L1 - Citra',
      'L1 - Dewi',
      'L2 - Eka',
      'L2 - Fajar',
      'L2 - Gita',
      'L2 - Hadi',
      'L3 - Indah (Lead)',
      'L3 - Jaya (Lead)',
    ],
    shiftHours: 12,
    workingDays: 7,
  },
];

export default function PresetSelector({ onSelectPreset, disabled }) {
  return (
    <div className="preset-selector-container">
      <div className="preset-header">
        <span className="preset-tag">DEMO PRESET 1-CLICK</span>
        <h3 className="preset-title">PILIH SKENARIO INDUSTRI</h3>
      </div>
      <div className="preset-grid">
        {PRESETS.map((preset) => (
          <button
            key={preset.id}
            className="preset-card"
            onClick={() => onSelectPreset(preset)}
            disabled={disabled}
          >
            <div className="preset-card-icon">{preset.icon}</div>
            <div className="preset-card-content">
              <div className="preset-card-title">{preset.title}</div>
              <div className="preset-card-subtitle">{preset.subtitle}</div>
              <div className="preset-card-desc">{preset.description}</div>
            </div>
            <div className="preset-card-badge">PAKAI →</div>
          </button>
        ))}
      </div>
    </div>
  );
}
